import React from 'react';

import { Heading } from '../../../../../../components/Heading/Heading';
import { LatLng } from '../../../../../../components/LatLng/LatLng';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner/LoadingSpinner';
import { Text } from '../../../../../../components/Text/Text';
import { useReefById } from '../../../../../../helpers/hooks/fishrules/useReefById';
import { MapDrawerLayout } from '../../MapDrawerLayout';
import { MapDrawerNotification } from '../../MapDrawerNotification/MapDrawerNotification';

interface IProps {
  artificialReefId: number;
}

export const ArtificialReefView = ({ artificialReefId }: IProps) => {
  const { isLoading, reef } = useReefById({ fishrulesReefId: artificialReefId });

  if (isLoading) {
    return (
      <MapDrawerLayout>
        <LoadingSpinner loadingText="Loading artificial reef..." />
      </MapDrawerLayout>
    );
  }

  if (!reef) {
    return (
      <MapDrawerLayout>
        <div className="flex h-full flex-col">
          <div className="flex">
            <Heading variant="sm" className="pr-2">
              Artificial Reef
            </Heading>
          </div>
          <MapDrawerNotification title="It looks like something went wrong" />
        </div>
      </MapDrawerLayout>
    );
  }

  const {
    description,
    type,
    longitude,
    latitude,
    structure,
    deploymentdate,
    region,
    depth_ft,
    name,
  } = reef;

  return (
    <div className="grid h-full grid-cols-1 grid-rows-1">
      <MapDrawerLayout className="col-start-1 row-start-1 h-full">
        <div className="flex h-full flex-col pt-2">
          {artificialReefId && (
            <>
              {/* eslint-disable-next-line no-constant-binary-expression */}
              {{ name } && (
                <Heading variant="xs" className="pr-16">
                  {' '}
                  {name}
                </Heading>
              )}
              {/* eslint-disable-next-line no-constant-binary-expression */}
              {{ latitude } && { longitude } && (
                <LatLng latitude={latitude} longitude={longitude} />
              )}
              {/* eslint-disable-next-line no-constant-binary-expression */}
              {{ region } && (
                <Text className="text-abyss" variant="md">
                  {region}
                </Text>
              )}
              {description && (
                <Text className="text-abyss" variant="md">
                  {description}
                </Text>
              )}
              {type && (
                <div className="mb-5">
                  <Heading variant="2xs" className="mb-3">
                    Type
                  </Heading>
                  {type}
                </div>
              )}
              {depth_ft && (
                <div className="mb-5">
                  <Heading variant="2xs" className="mb-3">
                    Depth(in ft)
                  </Heading>
                  {depth_ft}&apos;
                </div>
              )}
              {structure && (
                <div className="mb-5">
                  <Heading variant="2xs" className="mb-3">
                    Structure
                  </Heading>
                  {structure}
                </div>
              )}
              {deploymentdate && (
                <div className="mb-5">
                  <Heading variant="2xs" className="mb-3">
                    Deployment Date
                  </Heading>
                  {deploymentdate}
                </div>
              )}
            </>
          )}
        </div>
      </MapDrawerLayout>
    </div>
  );
};
